module.exports = __webpack_public_path__ + "img/google-authenticator.31db2762.svg";